import { Util } from '@libs/utilities/util';

import { EnumMbaFitType, EnumMbaProduct } from './contracts/mba-amazon.constants';
import { IAmazonMbaProduct, MBA_PRODUCT_SPECIFICATION } from './contracts/mba-products.constants';
import { IPodListing, IPodListingMba } from './contracts/pod-listing.interface';


export class MbaListingLegacyConverter {

	convertListing(listing: IPodListing | null): void {
		this.convertMbaListing(listing?.mba);
	}

	convertMbaListing(mbaListing: IPodListingMba | null | undefined): void {
		for (const product of mbaListing?.products || []) {
			product.fitTypes = this.convertFitTypes(product.productCode, product.fitTypes);
			// These formerly white-only products now use a printable background.
			const productConfig: IAmazonMbaProduct | undefined = MBA_PRODUCT_SPECIFICATION.find((spec: IAmazonMbaProduct) => spec.code === product.productCode);
			if (productConfig?.colors.defaultBackground) {
				product.background = product.background || productConfig.colors.defaultBackground;
				product.colors = [];
			}
		}
	}

	convertFitTypes(productCode: EnumMbaProduct, fitTypes: EnumMbaFitType[]): EnumMbaFitType[] {

		//0 - only Sweatshirt changed from the legacy men/women configuration
		if (productCode !== EnumMbaProduct.Sweatshirt) return fitTypes;

		//1 - replace either legacy adult fit with the new adult-unisex fit
		const hasLegacyAdultFit: boolean = fitTypes?.some((fitType: EnumMbaFitType) => [EnumMbaFitType.Men, EnumMbaFitType.Women].includes(fitType));
		if (!hasLegacyAdultFit) return fitTypes;

		const convertedFitTypes: EnumMbaFitType[] = fitTypes.filter((fitType: EnumMbaFitType) => ![EnumMbaFitType.Men, EnumMbaFitType.Women].includes(fitType));
		return Util.Array.unique([EnumMbaFitType.AdultUnisex, ...convertedFitTypes]);
	}
}
